// Copyright ©️ 2025 eVolve MEP, LLC

import type { LabelTypeId } from '@evolvemep/api-ts';

export const WORK_ORDER_LABEL_TYPE_ID = '932e1011-34d9-45d5-be56-6e88a536468a' as LabelTypeId;
